import { getAppEnv } from '@/lib/env'

export function serviceBaseUrl(service: string): string {
  const { backendDomain, backendPath } = getAppEnv()
  return `${backendDomain}${backendPath}/${service}`
}
